import React from 'react';
import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

import { getWidgetFillColor, getWidgetSecondaryFillColor } from '../../utils/utils';

const { useToken } = theme;

interface BlowerBackgroundProps {
  isSelected: boolean;
  mapView: boolean;
}

export const BlowerBackground = ({ isSelected, mapView }: BlowerBackgroundProps) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const widgetFillColor = getWidgetFillColor(isSelected, token);
  const widgetSecondaryFillColor = getWidgetSecondaryFillColor(isSelected, token);
  const detailsViewFillColor = isSelected ? token.Ecoplant_Compressor.colorBGSelected : token.colorBgElevated;

  return mapView ? (
    <svg className="background" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 243 144">
      <g fill="none" fillRule="evenodd">
        <path
          fill={widgetFillColor}
          d="M175,50 L175,0 L237,0 C238.104569,-2.02906125e-16 239,0.8954305 239,2 L239,142 C239,143.104569 238.104569,144 237,144 L2,144 C0.8954305,144 -9.09581476e-13,143.104569 -9.09494702e-13,142 L-9.09494702e-13,50 L175,50 Z"
        />
        <path
          fill={widgetSecondaryFillColor}
          d="M241,66 C242.104569,66 243,66.8954305 243,68 L243,76 C243,77.1045695 242.104569,78 241,78 L239,78 L239,66 L241,66 Z "
        />
        <path className="top-line-svg" fill={widgetFillColor} d="M239,0 L239,50 L0,50 L0,0 L239,0 Z" />
      </g>
    </svg>
  ) : (
    <svg className="background" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201.093 144">
      <g fill="none" fillRule="evenodd">
        <path
          fill={detailsViewFillColor}
          d="M175,50 L175,0 L237,0 C238.104569,-2.02906125e-16 239,0.8954305 239,2 L239,142 C239,143.104569 238.104569,144 237,144 L2,144 C0.8954305,144 -9.09581476e-13,143.104569 -9.09494702e-13,142 L-9.09494702e-13,50 L175,50 Z"
        />
        <path className="top-line-svg" fill={detailsViewFillColor} d="M239,0 L239,50 L0,50 L0,0 L239,0 Z" />
      </g>
    </svg>
  );
};
